export default "__VITE_ASSET__DFgSHvc1__"